import {ListToolbar} from './ListToolbar'
import {useQueryFilterDatesData} from '../../core/QueryResponseProvider'
import {formatDate} from '../../../../../../utils/dayJs/format'
import {useAuth} from '../../../../../../app/modules/auth'

interface Props {
  invoiceId?: number
}
const Header = ({invoiceId}: Props) => {
  const {currentFranchise} = useAuth()

  const filterDate = useQueryFilterDatesData()
  function isEmpty(obj: object): boolean {
    return Object.keys(obj).length === 0
  }

  return (
    <>
      <div className='card-header border-0 pt-6'>
        {/* <ListSearchComponent /> */}
        {/* begin::Card toolbar */}
        <div className='card-title'></div>

        <div className='card-toolbar'>
          {/* begin::Group actions */}
          {<ListToolbar franchiseId={currentFranchise?.id ?? 0} invoiceId={invoiceId} />}
          {/* end::Group actions */}
        </div>
        {/* end::Card toolbar */}
      </div>
      {isEmpty(filterDate) ? (
        ''
      ) : (
        <div className='card-header border-0'>
          <div className='card-title'></div>
          <div className='card-toolbar me-3'>
            Período Cadastro: {formatDate(filterDate.init)} - {formatDate(filterDate.end)}
          </div>
        </div>
      )}
    </>
  )
}

export {Header}
